import Player from '@vimeo/player';

( () => {
    const modalLink = document.querySelector( '.banner__modal-link' );
    const modalClose = document.querySelector( '.modal__close' );
    const frame = document.getElementById( 'modal' )?.querySelector( 'iframe' );

    if ( !frame ) return;
    const video = new Player( frame );
    modalLink?.addEventListener( 'click', () => video.play() );
    modalClose?.addEventListener( 'click', () => video.pause() );
} )();


const tabletBreakpoint = window.matchMedia( '(min-width: 39.9375rem)' );

// If matchMedia unsupported or if the media query is matched add the video sources
if ( !tabletBreakpoint || tabletBreakpoint.matches ) addVideoSources();

tabletBreakpoint.addEventListener( 'change', checkMediaQuery );

function checkMediaQuery( e ) {
    if ( e.matches ) addVideoSources();
}

function addVideoSources() {
    const videos = document.querySelectorAll( 'video[data-src]' );
    if ( !videos ) return;
    videos.forEach( video => {
        const source = document.createElement( 'source' );
        source.src = video.getAttribute( 'data-src' );
        video.appendChild( source );
    } );
    // Remove listener after video srcs have been added
    tabletBreakpoint.removeEventListener( 'change', checkMediaQuery );
}